import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { InitialStateProvider } from './contexts/InitialStateContext';
import App from './pages/LaravelError';

const Error = () => (
  <BrowserRouter>
    <InitialStateProvider>
      <App />
    </InitialStateProvider>
  </BrowserRouter>
);

render(<Error />, document.getElementById('app'));
